import { IconNames } from '@dixa/lib-shared-habla';
import { SearchUserEnriched } from 'lib-search-types';

import { getStatus } from './getStatus';
import { getWorkingChannels } from './getWorkingChannels';

export type PresenceIndicator = {
  icon: IconNames;
  tooltip: string;
};

type PresenceFlags = {
  hasActivePhoneConversation: boolean;
  isInACW: boolean;
  simultaneousRingEnabled: boolean;
};

export const getPresenceFlags = (
  member: SearchUserEnriched,
): PresenceFlags => ({
  hasActivePhoneConversation:
    (member.workloads_by_channel?.pstn_phone || 0) > 0,
  isInACW: member.has_acw ?? false,
  simultaneousRingEnabled: member.simultaneous_ring ?? false,
});

export const getPresenceIndicator = (
  member: SearchUserEnriched,
): PresenceIndicator => {
  const status = getStatus(member);
  const workingChannels = getWorkingChannels(member);
  const { hasActivePhoneConversation, isInACW, simultaneousRingEnabled } =
    getPresenceFlags(member);

  const isWorking = status === 'working';
  const isWorkingWithoutActiveChannel =
    isWorking && workingChannels.every(({ working }) => !working);

  let icon: IconNames = isWorkingWithoutActiveChannel
    ? 'circle'
    : 'circle-filled';
  let tooltip: string = isWorkingWithoutActiveChannel
    ? 'Online without active channel'
    : status;

  if (hasActivePhoneConversation) {
    icon = 'phone-filled';
    tooltip += ' - On a call';
  } else if (isInACW) {
    icon = 'circle-z';
    tooltip += ' - Wrap-up time';
  } else if (simultaneousRingEnabled) {
    icon = 'circle-simultaneous';
    tooltip += ' - Simultaneous ring enabled';
  }

  return { icon, tooltip };
};
